module.exports = __webpack_public_path__ + "static/img/logo-dzpng.84a0bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-dzpng.png
// module id = 9beW
// module chunks = 1